import { sampleSize } from 'lodash/collection';
import { random } from 'lodash/number';
import { difference } from 'lodash/array';
import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import isLoggedIn from '../utils/index';
import ToolTip from './CollageTooltip';
import BannerCard from './CollageBannerCard';

class CollageImage extends Component {
  state = {
    isTooltipActive: false
  };

  // We are hiding the tooltips below as an experiment
  // To show tooltips again this.setState({isTooltipActive: true});
  showTooltip() {
    this.setState({isTooltipActive: false});
  };

  hideTooltip() {
    this.setState({isTooltipActive: false});
  };

  render() {
    let { org } = this.props;
    if(!org) {
      return <span />;
    }

    let elID = 'collageImage' + org.id;
    let img_url = org.image_collage;
      if (org.image_collage == null) {
      img_url = '/images/www_logo.jpg';
    } else {
      img_url = org.image_collage;
    }
    return (
        <div className="home-collageImage"
             style={{ width: this.props.size + 'px', height: this.props.size + 'px'}}
        >
          
          <img id={elID}
               onMouseEnter={::this.showTooltip}
               onMouseLeave={::this.hideTooltip}
               className=""
               src={img_url}
               style={{ width: this.props.size + 'px', height: this.props.size + 'px'}} />
          <ToolTip active={this.state.isTooltipActive}
                   position="bottom"
                   arrow="center"
                   parent={'#'+elID}
                   tooltipTimeout={3000}>
          <div className="home-collageImagePopover">
            <div className="home-collageImagePopoverTitle">{org.name}</div>
            <div className="home-collageImagePopoverText">{org.thumbnail_text}</div>
            <Link to={'/organizations/' + org.id} className="home-collageImagePopoverLink"> Read More </Link>
          </div>
        </ToolTip>

      </div>
    );
  }
}


export default class HomeCollage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lastRefresh: null,
      intervalId: null,
      imageSize: null,
      columns: 10,
      rows: 5,
      orgs: [],
      collageWidth: this.props.browser.width,
      collageMaxWidth: this.props.browser.width,
      collageMargin: 180,
    };
  }

  // Resize the collage and header width on window resize
  // FYI: The initial header width is set in frontend/src/containers/Root.jsx
  // in componetReceiveProps 
  handleResize = () => {
    let { browser } = this.props;
    // Calculate the new collageWidth and collageMaxWidth values
    let newCollageMaxWidth, newCollageWidth;

    if (browser.lessThan.tablet) {
      return;
    }
    
    if (this.props.browser.width <= 1200) {
      newCollageMaxWidth = this.props.browser.width - 30;
    } else {
      newCollageMaxWidth = this.props.browser.width - this.state.collageMargin;
    }
    
    newCollageWidth = this.ensureMaxCollageWidth(this.props.browser.width, newCollageMaxWidth);

    // Update the state using this.setState()
    this.setState({
      collageWidth: newCollageWidth,
      collageMaxWidth: newCollageMaxWidth,
    });

    const collageWrapper = document.querySelector('header + div .content-wrapper .home-collage');
    const header = document.querySelector('header');
    if (collageWrapper) {
      const width = collageWrapper.offsetWidth;
      // set the width of the header to the width of the collage
      
      header.style.width = width + 'px';
    } 
}


  // Ensure collageWidth doesn't exceed a maximum value
  ensureMaxCollageWidth = (width, maxWidth) => {
    const maxCollageWidth = maxWidth; // Define your maximum width here
    return Math.min(width, maxCollageWidth);
  };

  refresh = () => {
    let { browser, collageOrganizations } = this.props;
    if (browser.lessThan.tablet) {
      return
    }
    let imageSize = Math.ceil(this.state.collageWidth / this.state.columns);
    let diff = difference(collageOrganizations, this.state.orgs);
    let substitute = sampleSize(diff)[0];
    let idx = random(1, this.state.rows * this.state.columns - 1);
    let { orgs } = this.state;
    orgs[idx] = substitute;
    this.setState({ imageSize, orgs });
  };

  generateCollageState = (props) => {
    const { browser, collageOrganizations } = props
    if (browser.lessThan.tablet || collageOrganizations.length == 0) {
      return {}
    }

    
    const collageWidth = this.ensureMaxCollageWidth(this.props.browser.width, this.state.collageMaxWidth);
    
    const numImages = this.state.rows * this.state.columns
    const imageSize = Math.ceil(this.state.collageWidth / this.state.columns)
    const orgs = sampleSize(collageOrganizations, numImages)

    let newState = {
      collageWidth,
      imageSize,
      orgs
    }
    if (!this.state.intervalId) {
      const intervalId = setInterval(this.refresh, 7000);
      newState.intervalId = intervalId
    }
    return newState
  }

  componentWillMount() {
    let { browser } = this.props;
    if (browser.lessThan.tablet) {
      return
    }
    if(this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
    
    if (this.props.browser.width <= 1200) {
      this.state.collageMaxWidth = this.props.browser.width - 30;
    } else {
      this.state.collageMaxWidth = this.props.browser.width - this.state.collageMargin;
    }
    
    this.state.collageWidth = this.ensureMaxCollageWidth(this.props.browser.width, this.state.collageMaxWidth);
    console.log(this.state.collageMaxWidth)
    this.props.loadCollageOrganizations();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.orgs.length === 0) {
      this.setState(this.generateCollageState(nextProps))
    }


  }

  componentDidMount() {
    // Add the resize event listener when the component mounts
    window.addEventListener('resize', this.handleResize);
    this.setState(this.generateCollageState(this.props))
  }

  render() {
    let { browser, auth, buttonCollage, header } = this.props;
    let { orgs } = this.state;
    let collageRotator = '';
    let collageWrapperWidth = '';
    let collageOverlayWrapperWidth = '';

    if (this.props.browser.width >= this.state.collageMaxWidth) {
      collageWrapperWidth = 1100;
    } else {
      collageWrapperWidth = this.props.browser.width;
    }


    if (browser.greaterThan.phablet) {
      let images = [];
      images = orgs.map(org => {
        function makeid() {
          var text = "";
          var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

          for( var i=0; i < 5; i++ )
            text += possible.charAt(Math.floor(Math.random() * possible.length));

          return text;
        }
        const key = `${makeid()}-${org.id}`

        return(
            <CollageImage key={key} org={org} size={this.state.imageSize} />
          );
      });
      collageRotator = (
          <div className="home-collageImages" style={{width: this.state.imageSize * this.state.columns + 'px'}}>
            {images}
          </div>
      );
    }

    let joinButton = '';
    joinButton = buttonCollage;

    if(auth.user && isLoggedIn()) {
      joinButton = <div className='home-collageTextTag'>{joinButton}  {this.props.auth.user.first_name} !</div>;
    }

    // Overlay info
    let overlayInfo = '';
    overlayInfo = {
      title: 'Global Resource Directory',
      tag: 'The place to find organizations and services exclusively for women around the world.',
      imgUrl: 'directory4.jpg',
      btnText: 'Sign up',
      btnUrl: '',
      learnMoreText: 'Find resources',
      learnMoreUrl: '/global-resource-directory',
      slug: 'directory',
      isExternalUrl: false
    }


    // Overlay from slider
    let collageOverlay = '';
    collageOverlay = <div>
      <BannerCard
        title = {overlayInfo.title}
        tag = {overlayInfo.tag}
        imgUrl = {overlayInfo.imgUrl}
        btnText = {overlayInfo.btnText}
        btnUrl = {overlayInfo.btnUrl}
        learnMoreText = {overlayInfo.learnMoreText}
        learnMoreUrl = {overlayInfo.learnMoreUrl}
        slug = {overlayInfo.slug}
        isExternalUrl = {overlayInfo.isExternalUrl}
        openSignupFormRequest = {this.props.openSignupFormRequest}
      />
    </div>
          

    return (
      <div style={{margin: '0 auto', width: this.state.collageMaxWidth }} className="home-collage">

        <div className="home-collageBanner" style={{width: this.state.collageMaxWidth + 'px', overflow: 'hidden', margin: '0 auto'}}>
          

          <div className="home-collageOverlay-wrapper">
            
            {collageOverlay}
          </div>
          {collageRotator}
        </div>


        
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/HomeCollage.jsx